import { Tooltip } from 'antd';

import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

import { useNewCredential } from './new-credential.hook';
import {
  CredentialButtonTitle,
  CredentialIcon,
  NewCredentialButton,
  NewCredentialWrapper,
} from './new-credential.style';

export const NewCredential = () => {
  const { onAdd, isLoading, shouldEdit } = useNewCredential();

  return (
    <NewCredentialWrapper>
      <Tooltip
        color={ColorEnum.Error100}
        placement='top'
        title={
          shouldEdit ? (
            ''
          ) : (
            <Text color={ColorEnum.Inherit} level='s'>
              You don&apos;t have permission
            </Text>
          )
        }
      >
        <NewCredentialButton
          disabled={!shouldEdit}
          icon={<CredentialIcon />}
          loading={isLoading}
          type={ButtonTypeEnum.Primary}
          block
          ghost
          onClick={onAdd}
        >
          <CredentialButtonTitle>Add credential</CredentialButtonTitle>
        </NewCredentialButton>
      </Tooltip>
    </NewCredentialWrapper>
  );
};
